import { render, staticRenderFns } from "./CompanyBank.vue?vue&type=template&id=6c28516d&scoped=true"
import script from "./CompanyBank.vue?vue&type=script&lang=js"
export * from "./CompanyBank.vue?vue&type=script&lang=js"
import style0 from "./CompanyBank.vue?vue&type=style&index=0&id=6c28516d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28516d",
  null
  
)

export default component.exports